import css from '@styled-system/css';
import { createGlobalStyle } from 'styled-components';
import { ThemeStyles } from '@honda-canada/design-system-react';
export const ScrollSnapGlobalCss = createGlobalStyle(({ inView }) => css({
    ':root': {
        scrollSnapType: inView ? 'y mandatory' : 'initial',
    },
}));
const themeStyles = new ThemeStyles();
themeStyles.addBaseStyles('TimelineBoxContainer')(css({
    display: 'flex',
    marginBottom: '40px',
}));
themeStyles.addBaseStyles('DecadesSection')(({ inView }) => css({
    width: '100%',
    marginTop: '48px',
    paddingTop: '10px',
    backgroundColor: 'white',
    zIndex: inView ? 2000 : 0,
    position: 'sticky',
    top: '64px',
}));
themeStyles.addBaseStyles('DecadesContainer')(({ theme }) => css({
    display: 'flex',
    gap: theme.space.default,
    justifyContent: 'center',
    alignItems: 'center',
}));
themeStyles.addBaseStyles('DecadeContainer')(css({
    height: 'fit-content',
    width: '100%',
}));
themeStyles.addBaseStyles('YearsContainer')(css({
    display: 'flex',
    flexDirection: 'column',
    height: 'calc(100vh - 100px)',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '0 50px',
    position: 'sticky',
    backgroundColor: 'white',
    top: '100px',
}));
themeStyles.addBaseStyles('TimelineItemContainer')(css({
    height: '100%',
    width: '100%',
}));
themeStyles.addBaseStyles('YearContainer')({
    scrollSnapAlign: 'start',
});
themeStyles.addBaseStyles('ProgressContainer')(({ isVisible }) => css({
    display: isVisible ? 'block' : 'none',
    position: 'absolute',
    bottom: '0',
    left: '0',
    right: '0',
    height: '3px',
    transition: 'height 0.3s ease,background-color 0.3s ease',
    backgroundColor: 'grey.3',
}));
themeStyles.addBaseStyles('ProgressContainerWidth')(css({
    height: '100%',
    backgroundColor: 'red',
    transition: 'color 0.2s ease,background-color 0.2s ease, width 0.2s ease',
}));
themeStyles.addBaseStyles('AccordionTitleText')(css({
// transition: 'all 0.3s ease',
}));
export default themeStyles;
